import { useLocation, useNavigate } from 'react-router'
import PostsRoute from './PostsRoute'
import { CalendarRoute } from './CalendarRoute'
import { useSelector } from 'react-redux'
import { plannedPostsLayoutSelector } from 'services/post/selectors'
import { useEffect } from 'react'

export function PostsRoot() {
  const navigate = useNavigate()
  const activeView = useSelector(plannedPostsLayoutSelector)
  const location = useLocation()

  // NOTE: Calendar view is supported only on the `/posts/planned/all` route. Navigate to this route if calendar is selected
  useEffect(() => {
    if (activeView === 'calendar' && location.pathname !== '/posts/planned/all') {
      navigate('/posts/planned/all')
    }
  }, [activeView, location.pathname, navigate])

  if (activeView === 'calendar') {
    return <CalendarRoute />
  }

  return <PostsRoute />
}
